import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { CollaborateurService } from '@shared/services/cabinet/collaborateur.service';
import { versPageArrivee, refusVersAccueil } from '../page-arrivee';
import { NotificationService } from '../../ui/notification/notification.service';
import { droitGestionInterne, MSG_ECRAN_NON_AUTORISE } from '../droits';

/** Garde des pages collaborateur : sinon renvoie vers la page d'arrivée de l'utilisateur (versPageArrivee). */
export const collabOnlyGuard: CanActivateFn = () => (inject(CollaborateurService).isCollab ? true : versPageArrivee());

/**
 * Écran collaborateur d'un dossier ouvert par un client (adresse tapée, lien) : jamais « Écran en cours de refonte »
 * ni « Page introuvable », mais le refus habituel (message) et l'accueil du dossier. Voir refusAuClient (app.routes.ts).
 */
export const ecranReserveCollabGuard: CanActivateFn = (route) => {
  inject(NotificationService).erreur(MSG_ECRAN_NON_AUTORISE);
  return refusVersAccueil(route);
};

/**
 * Écrans réservés au droit « Gestion interne » (core/droits.ts, droitGestionInterne) : espace Gestion interne et
 * entrées du Paramétrage et des Outils réservées à ce droit au bureau. Sans le droit (adresse tapée, lien) : refus
 * habituel (message) et liste des dossiers.
 */
export const gestionInterneGuard: CanActivateFn = () => {
  if (droitGestionInterne()) {
    return true;
  }
  inject(NotificationService).erreur(MSG_ECRAN_NON_AUTORISE);
  return versPageArrivee();
};
